var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-icon-group2",
    transform: "translate(-827.000000, -138.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-icon-group3",
    transform: "translate(827.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5555556,11.5555556 L1.44444444,11.5555556 L1.44444444,1.44444444 L6.5,1.44444444 L6.5,0 L1.44444444,0 C0.642777778,0 0,0.65 0,1.44444444 L0,11.5555556 C0,12.35 0.642777778,13 1.44444444,13 L11.5555556,13 C12.35,13 13,12.35 13,11.5555556 L13,6.5 L11.5555556,6.5 L11.5555556,11.5555556 Z M7.94444444,0 L7.94444444,1.44444444 L10.5372222,1.44444444 L3.43777778,8.54388889 L4.45611111,9.56222222 L11.5555556,2.46277778 L11.5555556,5.05555556 L13,5.05555556 L13,0 L7.94444444,0 Z",
    id: "link-icon-group4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.ed423e67.svg";
export { ForwardRef as ReactComponent };